import { render, staticRenderFns } from "./system_logs.vue?vue&type=template&id=2c3e937d"
import script from "./system_logs.vue?vue&type=script&lang=ts"
export * from "./system_logs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports